import React from 'react';
import logo from '../../../../../images/modules/RunUp-logo.svg';
import './index.scss';

export const Header = () => {
    return (
        <div className='runup-header'>
            <div className='runup-header__logo'>
                <img src={logo} alt='logo' />
            </div>
            <div className='runup-header__items'>
                <div className='runup-header__item'>Shoes & Gear</div>
                <div className='runup-header__item'>Training</div>
                <div className='runup-header__item'>Health & Injuries</div>
                <div className='runup-header__item'>Beginners</div>
                <div className='runup-header__item'>Must Read</div>
                <div className='runup-header__item subscribe'>Subscribe</div>
            </div>
        </div>
    );
};
